module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__Itau_Min.cd4a1a8d.svg";